<template>
    <input
        v-bind="$attrs"
        type="checkbox"
        :id="id"
        :chcked="modelValue"
        @change="$emit('update:modelValue', handleInputChange($event))"
        class="input-item__checkbox"
    >

    <label
        :for="id"
        v-html="label"
        class="input-item__checkbox__label"
        :class="{ 'checked': inputValue }"
    ></label>

    <!-- <div class="input-item" :class="{ 'input-item--error': v$ && v$.$error }">
        <input
            v-model="inputValue"
            :id="id"
            type="checkbox"
            class="input-item__checkbox"
            @update:modelValue="change"
        />

        <label
            :for="id"
            v-html="label"
            class="input-item__checkbox__label"
            :class="{ 'checked': inputValue }"
        >
        </label>

        <div class="input-item__error" v-if="v$ && v$.$error">
            <span v-if="v$.inputValue.sameAs" class="input-item__error__msg">Fältet är obligatoriskt</span>
        </div>
    </div> -->
</template>

<script lang="ts">
    import { defineComponent, toRefs, watchEffect, computed, reactive } from 'vue'
    import { required, sameAs } from '@vuelidate/validators'
    import useVuelidate from '@vuelidate/core'

    export default defineComponent({
        props: {
            modelValue: {
                type: Boolean,
                required: false
            },
            keyn: {
                type: String,
                required: false
            },
            id: {
                type: Number,
                required: false
            },
            label: {
                type: String,
                required: false
            },
            validators: {
                type: String,
                required: false
            }
        },
        setup(props, { emit }) {
            let v$ = useVuelidate()

            const state = reactive({
                inputValue: false as boolean,
                id: `_${ Math.random().toString(36).substr(2, 9) }`
            })

            const hasValidation = props.validators !== undefined

            const touch = () => v$.value.inputValue.$touch()

            const handleInputChange = (event: Event) => (event.target as HTMLInputElement).checked

            // const change = (value: boolean) => {
            //     if (props.keyn) {
            //         emit('update:modelValue', {
            //             type: 'checkbox',
            //             key: props.keyn,
            //             id: props.id,
            //             value: value
            //         })
            //     } else {
            //         emit('update:modelValue', value)
            //     }

            //     if (hasValidation) {
            //         touch()
            //     }
            // }

            if (hasValidation) {
                const RuleRequired = props.validators?.includes('required')

                let activeRoles: any = {}

                if (RuleRequired) {
                    activeRoles.inputValue = { sameAs: sameAs(true) }
                }

                const rules = computed(() => activeRoles)

                v$ = useVuelidate(rules, state)
            }

            watchEffect(() => {
                state.inputValue = props.modelValue as boolean
            })

            return {
                 v$,
                ...toRefs(state),
                handleInputChange
            }
        }
    })
</script>
